export default (state = {}, {errorCode}) => {
  if (!errorCode || !(errorCode in state)) {
    return state;
  }

  return {
    ...state,
    [errorCode]: false,
  };
};
